import { useState, useEffect, useCallback } from 'react';
import { getTournamentStats } from '@/api/TournamentManagement/tournamentApi';
import type { TournamentStatsView } from '@/models/tournament';

export function useTournamentStats() {
  const [data, setData] = useState<TournamentStatsView | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await getTournamentStats();
      if (result.status < 400 && result.errors.length === 0) {
        setData(result.payload);
      } else {
        setError(result.errors[0]?.description || 'An error occurred');
      }
    } catch {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, loading, error, refetch: fetch };
}
